import AttachmentsDrawer from 'tio-common/components/tas/approval/drawers/attachments';
import type { TOC } from '@ember/component/template-only';
import type { TasApplicationExtension as TasApplicationModel } from 'tio-data/data/resources/tas-application.ext';
import type { TasAssetExtension as TasAssetModel } from 'tio-data/data/resources/tas-asset.ext';

interface ManageAttachmentsDrawerSignature {
  Args: {
    application: TasApplicationModel;
    allAttachments: TasAssetModel[];
  };
}

/**
 * Read-only Attachments drawer for the employee "manage" screen — shows what
 * evidence has already been uploaded for this application. Uploading new
 * evidence stays in the Submit Evidence task's own flow (CategorizedUpload /
 * UploadAttachments, wired in needs-your-attention/task-card/submit-evidence.gts),
 * so this renders only the shared drawer's TableView block, never its
 * UploadSection, and passes `@disabled={{true}}` to hide the Delete action too
 * — viewing what's there shouldn't also expose deleting it from a second place.
 */
const ManageAttachmentsDrawer: TOC<ManageAttachmentsDrawerSignature> = <template>
  <AttachmentsDrawer
    @model={{@application}}
    @allAttachments={{@allAttachments}}
    @disabled={{true}}
    as |sections|
  >
    <sections.TableView
      @sortedAttachments={{sections.tableProps.sortedAttachments}}
      @getFileIcon={{sections.tableProps.getFileIcon}}
      @getClassificationLabel={{sections.tableProps.getClassificationLabel}}
      @isDeleted={{sections.tableProps.isDeleted}}
      @deleteAttachment={{sections.tableProps.deleteAttachment}}
      @disabled={{sections.tableProps.disabled}}
      @showUploadSection={{sections.tableProps.showUploadSection}}
    />
  </AttachmentsDrawer>
</template>;

export default ManageAttachmentsDrawer;
